"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectParticipantModalComponent = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const antd_1 = require("antd");
const lodash_1 = __importDefault(require("lodash"));
const principal_1 = require("@dfinity/principal");
const useForm_1 = __importDefault(require("antd/lib/form/hooks/useForm"));
const ProjectParticipantsDataProvider_1 = require("src/configeek_assets/src/components/common/provider/ProjectParticipantsDataProvider");
const TextTruncated_1 = require("src/configeek_assets/src/components/common/widget/TextTruncated");
const promiseUtils_1 = require("src/configeek_assets/src/system/mics/promiseUtils");
const ICCanisterUtils_1 = require("src/configeek_assets/src/ic/ICCanisterUtils");
const i18_1 = require("src/configeek_assets/src/i18");
const Analytics_1 = require("src/configeek_assets/src/system/analytics/Analytics");
const limits_1 = require("src/configeek_assets/src/limits");
const formRules = {
    name: [{ required: true, message: "Name is required" }],
    principal: [{
            required: true,
            message: "Principal is required",
        }, {
            validator: async (rule, value) => {
                if (lodash_1.default.isEmpty(value)) {
                    return Promise.resolve();
                }
                try {
                    if (lodash_1.default.size(value) != limits_1.PARTICIPANT_PRINCIPAL_EXACT_LENGTH) {
                        // noinspection ExceptionCaughtLocallyJS
                        throw new Error("Bad principal");
                    }
                    const principalFromValue = principal_1.Principal.fromText(value);
                    if (principalFromValue.isAnonymous()) {
                        return Promise.reject(new Error('Non anonymous principal is required'));
                    }
                    return Promise.resolve();
                }
                catch (e) {
                    return Promise.reject(new Error('Valid principal is required'));
                }
            }
        }]
};
const modalButtonsPropsInitialValue = {
    ok: { disabled: true },
    cancel: {}
};
const ProjectParticipantModalComponent = (props) => {
    const projectParticipantsDataContext = (0, ProjectParticipantsDataProvider_1.useProjectParticipantsDataContext)();
    const [form] = (0, useForm_1.default)();
    const [modalButtonProps, setModalButtonProps] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), modalButtonsPropsInitialValue);
    const isCreate = props.participantView == undefined;
    const initialValues = {
        principal: isCreate ? "" : props.participantView ? props.participantView.principal.toText() : "",
        name: isCreate ? "" : props.participantView ? props.participantView.name : ""
    };
    const title = isCreate ?
        React.createElement(React.Fragment, null,
            "Invite to ",
            React.createElement(TextTruncated_1.TextTruncated, { text: props.projectView.projectName, length: 40 })) :
        React.createElement(React.Fragment, null, "Edit member");
    const okText = isCreate ? "Invite" : "Update";
    const errorText = isCreate ? i18_1.i18.project.members.error.modal.invite : i18_1.i18.project.members.error.modal.edit;
    const addCancellable = (0, promiseUtils_1.makeCancelableAsync)(async (participantPrincipal, participantName) => {
        // if (!!process.env.IS_TEST_SERVER) {
        //     throw new Error("AAA")
        // }
        const addNewViewerParticipantResult = await projectParticipantsDataContext.addNewViewerParticipant(participantPrincipal, participantName);
        if (addNewViewerParticipantResult.status === "success") {
            Analytics_1.Analytics.trackInviteMember();
            projectParticipantsDataContext.fetchParticipants();
        }
        return addNewViewerParticipantResult;
    });
    const updateCancellable = (0, promiseUtils_1.makeCancelableAsync)(async (participantPrincipal, participantName) => {
        // if (!!process.env.IS_TEST_SERVER) {
        //     throw new Error("AAA")
        // }
        const updateParticipantResult = await projectParticipantsDataContext.updateParticipant(participantPrincipal, participantName);
        if (updateParticipantResult.status === "success") {
            projectParticipantsDataContext.fetchParticipants();
        }
        return updateParticipantResult;
    });
    const asyncAdd = async (formValues) => {
        try {
            const { principal, name } = formValues;
            //disabled buttons
            setModalButtonProps({
                ok: { disabled: true, loading: true, },
                cancel: { disabled: true, }
            });
            const result = await addCancellable.run(principal_1.Principal.fromText(principal), name);
            switch (result.state) {
                case "success": {
                    const addNewViewerParticipantResult = result.result;
                    if (!!process.env.IS_TEST_SERVER) {
                        console.log("asyncAdd addCancellable result", addNewViewerParticipantResult);
                    }
                    switch (addNewViewerParticipantResult.status) {
                        case "success": {
                            props.onDestroy();
                            break;
                        }
                        case "error": {
                            // const reason = addNewViewerParticipantResult.reason;
                            //enabled buttons
                            setModalButtonProps({
                                ok: { disabled: false, loading: false, },
                                cancel: { disabled: false, }
                            });
                            //update errors
                            form && form.setFields([{ name: "name", errors: [errorText] }]);
                            break;
                        }
                        case "unknownError": {
                            throw addNewViewerParticipantResult.error;
                        }
                    }
                    break;
                }
                case "cancelled": {
                    //skip
                    break;
                }
                case "error": {
                    // noinspection ExceptionCaughtLocallyJS
                    throw result.error;
                }
            }
        }
        catch (e) {
            const error = ICCanisterUtils_1.ICRestError.withUnknownError(e);
            console.error("ProjectParticipantModalComponent: putConfigKey failed", error);
            //enabled buttons
            setModalButtonProps({
                ok: { disabled: false, loading: false, },
                cancel: { disabled: false, }
            });
            //update errors
            form && form.setFields([{ name: "name", errors: [errorText] }]);
        }
    };
    const asyncUpdate = async (formValues) => {
        try {
            const { principal, name } = formValues;
            //disabled buttons
            setModalButtonProps({
                ok: { disabled: true, loading: true, },
                cancel: { disabled: true, }
            });
            const result = await updateCancellable.run(principal_1.Principal.fromText(principal), name);
            switch (result.state) {
                case "success": {
                    const updateParticipantResult = result.result;
                    if (!!process.env.IS_TEST_SERVER) {
                        console.log("asyncUpdate updateCancellable result", updateParticipantResult);
                    }
                    switch (updateParticipantResult.status) {
                        case "success": {
                            props.onDestroy();
                            break;
                        }
                        case "error": {
                            // const reason = updateParticipantResult.reason;
                            //enabled buttons
                            setModalButtonProps({
                                ok: { disabled: false, loading: false, },
                                cancel: { disabled: false, }
                            });
                            //update errors
                            form && form.setFields([{ name: "name", errors: [/*`error: ${reason}`*/ errorText] }]);
                            break;
                        }
                        case "unknownError": {
                            throw updateParticipantResult.error;
                        }
                    }
                    break;
                }
                case "cancelled": {
                    //skip
                    break;
                }
                case "error": {
                    // noinspection ExceptionCaughtLocallyJS
                    throw result.error;
                }
            }
        }
        catch (e) {
            const error = ICCanisterUtils_1.ICRestError.withUnknownError(e);
            console.error("ProjectParticipantModalComponent: putConfigKey failed", error);
            //enabled buttons
            setModalButtonProps({
                ok: { disabled: false, loading: false, },
                cancel: { disabled: false, }
            });
            //update errors
            form && form.setFields([{ name: "name", errors: [errorText] }]);
        }
    };
    const onFormFieldsChange = (changedFields, allFields) => {
        let valid = true;
        for (const idx in allFields) {
            const field = allFields[idx];
            if (field.errors && field.errors.length > 0) {
                valid = false;
            }
        }
        setModalButtonProps({
            ok: { disabled: !valid }
        });
    };
    const onFormFinish = async (values) => {
        if (isCreate) {
            await asyncAdd(values);
        }
        else {
            await asyncUpdate(values);
        }
    };
    const onCancel = () => {
        props.onDestroy();
    };
    const onOk = async () => {
        if (form) {
            try {
                const values = await form.validateFields();
                await onFormFinish(values);
            }
            catch (info) {
                // console.log('Validate Failed:', info);
            }
        }
    };
    const submitForm = (0, react_1.useCallback)(args => {
        if (!modalButtonProps.ok.disabled) {
            form && form.submit();
        }
    }, [modalButtonProps.ok.disabled]);
    return React.createElement(antd_1.Modal, { width: 550, closable: false, maskClosable: false, destroyOnClose: true, visible: props.visible, title: title, onCancel: onCancel, okText: okText, onOk: onOk, okButtonProps: modalButtonProps.ok, cancelButtonProps: modalButtonProps.cancel, className: "ug-modal" },
        React.createElement(antd_1.Form, { form: form, layout: "vertical", requiredMark: false, initialValues: initialValues, onFinish: onFormFinish, onFieldsChange: onFormFieldsChange },
            React.createElement(antd_1.Form.Item, { name: "principal", label: "Principal", rules: formRules.principal },
                React.createElement(antd_1.Input, { autoFocus: isCreate, disabled: !isCreate, maxLength: limits_1.PARTICIPANT_PRINCIPAL_EXACT_LENGTH, onPressEnter: submitForm })),
            React.createElement(antd_1.Form.Item, { name: "name", label: "Name", rules: formRules.name },
                React.createElement(antd_1.Input, { autoFocus: !isCreate, maxLength: limits_1.PARTICIPANT_NAME_MAXLENGTH, onPressEnter: submitForm }))));
};
exports.ProjectParticipantModalComponent = ProjectParticipantModalComponent;
